export default __webpack_public_path__ + "static/media/spock.e5bb1af0.png";